import { render } from "./LoginTest.vue?vue&type=template&id=74fc75be"
import script from "./LoginTest.vue?vue&type=script&lang=js"
export * from "./LoginTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__